import type {LocationDetectedVariant, PickupStation} from '../index'
import type {Parcel} from './parcel'
import type {Point} from './point'

export type DestinationPoint = Point & {
  _type: 'destination'
  _deliveryMethod: DestinationPointDeliveryMethod
  // ПВЗ - пункт выдачи заказа. Актуально для NDD
  pickUpPoint: {
    city?: LocationDetectedVariant
    point?: PickupStation
  }
  // Посылки в заказе
  parcels: Array<Parcel>
  // Оплата при получении
  paymentOnDelivery: boolean
}

export const enum DestinationPointDeliveryMethod {
  Address = 'address',
  PickUpPoint = 'pickUpPoint',
}
